export const ManualObj : ManualT = {
    id: null,
    blurb: '',
    fk_company: null,
    fk_sections: '',
    sections: []
}

export interface ManualT {
    id : number
    blurb : string
    fk_company : number
    fk_sections : string
    sections : any          // TODO: FIX THIS 'any'
}

export interface SectionT {
    id : number
    blurb : string
    fk_pages : string
    section_title : string
}